module.exports = __webpack_public_path__ + "static/media/infiniti-parking-selected.fbe967d0.svg";